import React from 'react';
import * as MuiCore from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import InfoIcon from '@material-ui/icons/Info';

// Map database field types to display names 
const getFieldTypeDisplayName = (fieldType) => {
    const typeMap = {
        'caller': 'Caller',
        'phonenumber': 'Phone Number',
        'text': 'Text',
        'email': 'Email',
    };
    return typeMap[fieldType?.toLowerCase()] || fieldType;
};

const FormFieldsCard = ({ 
    form,
    loading,
    onEdit,
    classes 
}) => {
    const activeVersion = form?.activeVersion;
    const fields = activeVersion?.formFields || [];

    return (
        <MuiCore.Box className={classes.section}>
            <MuiCore.Box className={classes.sectionHeader}>
                <MuiCore.Box className={classes.sectionTitle}>
                    <InfoIcon />
                    <MuiCore.Typography variant="h6" style={{ fontFamily: 'Sofia-bold' }}>Call Form</MuiCore.Typography>
                </MuiCore.Box>
                {!loading && activeVersion && (
                    <MuiCore.Button
                        startIcon={<EditIcon />}
                        className={classes.editButton}
                        variant="outlined"
                        onClick={onEdit}
                    >
                        EDIT
                    </MuiCore.Button>
                )}
            </MuiCore.Box>
            <MuiCore.Typography variant="body2" color="textSecondary" style={{ marginBottom: 16, fontFamily: 'Sofia' }}>
                Customize the information that your Grasshopper AI will gather. These fields will be included on any messages.
            </MuiCore.Typography>

            {loading ? (
                <MuiCore.Box style={{ display: 'flex', justifyContent: 'center', padding: 40 }}>
                    <MuiCore.CircularProgress />
                </MuiCore.Box>
            ) : !form ? (
                <MuiCore.Typography style={{ fontFamily: 'Sofia', fontStyle: 'italic', textAlign: 'center', padding: 20, color: '#999' }}>
                    Call forms feature requires database setup. Contact your administrator.
                </MuiCore.Typography>
            ) : fields.length === 0 ? (
                <MuiCore.Typography style={{ fontFamily: 'Sofia', fontStyle: 'italic', textAlign: 'center', padding: 20 }}>
                    No form fields configured. Click EDIT to add fields.
                </MuiCore.Typography>
            ) : (
                <MuiCore.TableContainer>
                    <MuiCore.Table>
                        <MuiCore.TableHead>
                            <MuiCore.TableRow>
                                <MuiCore.TableCell style={{ fontFamily: 'Sofia-bold' }}>Field Name</MuiCore.TableCell>
                                <MuiCore.TableCell style={{ fontFamily: 'Sofia-bold' }}>Type</MuiCore.TableCell>
                                <MuiCore.TableCell style={{ fontFamily: 'Sofia-bold' }}>Required</MuiCore.TableCell>
                                <MuiCore.TableCell style={{ fontFamily: 'Sofia-bold' }}>Verify</MuiCore.TableCell>
                            </MuiCore.TableRow>
                        </MuiCore.TableHead>
                        <MuiCore.TableBody>
                            {fields.map((field, index) => (
                                <MuiCore.TableRow key={field.formFieldId || index}>
                                    <MuiCore.TableCell style={{ fontFamily: 'Sofia' }}>
                                        {field.label || field.property}
                                    </MuiCore.TableCell>
                                    <MuiCore.TableCell style={{ fontFamily: 'Sofia' }}>
                                        {getFieldTypeDisplayName(field.fieldType)}
                                    </MuiCore.TableCell>
                                    <MuiCore.TableCell style={{ fontFamily: 'Sofia' }}>
                                        {field.required === 'Y' ? 'Yes' : 'No'}
                                    </MuiCore.TableCell>
                                    <MuiCore.TableCell style={{ fontFamily: 'Sofia' }}>
                                        {field.verify === 'Y' ? 'Yes' : 'No'}
                                    </MuiCore.TableCell>
                                </MuiCore.TableRow>
                            ))}
                        </MuiCore.TableBody>
                    </MuiCore.Table>
                </MuiCore.TableContainer>
            )}
        </MuiCore.Box>
    );
};

export default FormFieldsCard;
